import { useRouter } from "next/router";
import React from "react";

export function useStateFromRouterQuery<T>({
  name,
  toValue,
  fromValue,
}: {
  name: string;
  toValue: (text: string) => T;
  fromValue: (value: T) => string;
}) {
  const router = useRouter();

  const getInitialState = () => {
    const queryValue = router.query[name];
    const text = typeof queryValue === "string" ? queryValue : "";
    return toValue(text);
  };

  const [state, setState] = React.useState<T>(getInitialState);

  return {
    value: state,
    setValue: (value: T) => {
      // 1. Update internal state
      setState(value);

      // 2. Update url
      const text = fromValue(value);
      const search = new URLSearchParams(location.search);
      if (!text) {
        search.delete(name);
      } else {
        search.set(name, text);
      }
      const url = new URL(location.href);
      url.search = search.toString();
      history.replaceState(history.state, "", url);
    },
  };
}
